export const VN_COUNTRY_CODE: string = 'VN';

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  MALE_SHORT = 'M',
  FEMALE_SHORT = 'F',
}

export const DATE_FORMATS = {
  DATE_MONTH_YEAR: 'DD/MM/YYYY',
  YEAR_MONTH_DATE: 'YYYY-MM-DD',
};

export const MB_LINK = 'https://www.mblife.vn/'

export enum PayFrequency {
  
}

export enum statusPolicy {
  Active = "Đang hiệu lực",
  Lapsed = "Mất hiệu lực",
}

export const payFrequency = [
  {
    id: "Annually",
    name: 'Hàng năm'
  },
  {
    id: "Quarterly",
    name: 'Hàng quý'
  },{
    id: "Semi-Annually",
    name: 'Nửa năm'
  },{
    id: "Monthly",
    name: 'Hàng tháng'
  },{
    id: "Biweekly",
    name: 'Hai tuần một lần'
  },{
    id: "Weekly",
    name: 'Hàng tuần',
  },
  {
    id: "Single Premium",
    name: 'Đóng phí một lần',
  },
]
export const textButton = {
  backHome:"Về trang chủ",
  query:"Truy vấn",
  backApp:"Tiếp tục tạo yêu cầu",
}

export const PaymentResultSuccess = 'paymented'

export const DefaultHeaderToSystm = 'defaultToSystem' // required send with api but any value
export const DefaultHeaderFrSystm = 'defaultFromSystem' // required send with api but any value
